import { Component, OnDestroy } from '@angular/core';
import { ModalsService } from "../../../../../common/src/lib/services/modals.service";
import { PaymentService } from "../../services/payment.service";
import { decimalOnly, isEmpty, onDecimalPaste } from "../../helpers/forms";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-refund-payment',
  templateUrl: './refund-payment.component.html',
  styleUrls: ['./refund-payment.component.scss']
})
export class RefundPaymentComponent implements OnDestroy {

  protected readonly onDecimalPaste = onDecimalPaste;
  protected readonly decimalOnly = decimalOnly;
  protected readonly onPaste = onDecimalPaste;

  amountControl = new FormControl((+this.modalsService.data.amount - +this.modalsService.data.alreadyRefunded).toFixed(2));
  amountControlSubscription: Subscription;
  overAmount = false;
  empty = false;
  failedToRefund = false;
  loading = false;

  get transactionNumber() {
    return this.modalsService.data?.transactionNumber ?? null;
  }

  constructor(
    private modalsService: ModalsService,
    private paymentService: PaymentService
  ) {
    this.amountControlSubscription = this.amountControl.valueChanges.subscribe(_ => {
      this.overAmount = false;
      this.empty = false;
      this.failedToRefund = false;
    });
  }

  ngOnDestroy() {
    this.amountControlSubscription?.unsubscribe();
  }

  async close() {
    await this.modalsService.close();
  }

  async addRefund() {
    if (this.isValid() && !this.loading) {
      this.loading = true;
      try {
        await this.paymentService.addRefund(
          +this.amountControl.value!,
          this.modalsService.data.workflowId,
          this.modalsService.data.paymentId,
          this.modalsService.data.paidId
        );

        await this.close();
      } catch (e) {
        console.log('Something went wrong during refund.');
        this.failedToRefund = true;
      } finally {
        this.loading = false;
      }
    }
  }

  isValid(): boolean {
    if (isEmpty(this.amountControl.value)) {
      this.empty = true;
      return false;
    }

    if (+this.amountControl.value! > Math.round((+this.modalsService.data.amount - +this.modalsService.data.alreadyRefunded) * 100) / 100) {
      this.overAmount = true;
      return false;
    }

    return true;
  }
}
